import React from "react";
import {ActionRow, ActionRowButton, ActionRowMoreButton, Icon} from "peggirkit";
import {ArrowTopRightOnSquareIcon, ClockIcon, PlusIcon} from "@heroicons/react/24/outline";
import {FormattedMessage, useIntl} from "react-intl";
import router from "@/routing/Router";
import clockedStatusFilter from "@widgets/employees/overview/heading/ClockedStatusFilter";
import {useTooltip} from "@components/widgets/tooltip/TooltipProvider";
import {SetURLSearchParams} from "react-router-dom";
import {ClockedFilterStatus} from "@widgets/employees/overview/Employees";

type Props = {
    statusFilter: ClockedFilterStatus;
    setSearchParams: SetURLSearchParams;
};

const EmployeesPageHeadingActions = ({statusFilter, setSearchParams}: Props) => {
    const intl = useIntl();
    const {applyTooltip} = useTooltip();

    return (
        <ActionRow
            useMoreButton={true}
            moreButton={
                <ActionRowMoreButton>
                    <FormattedMessage id={"more"}/>
                </ActionRowMoreButton>
            }
            moreButtonPositioning={"end"}
            breakpoints={{
                md: {
                    moreButtonPositioning: "start",
                },
            }}
        >
            <ActionRowButton
                color={"secondary"}
                iconBefore={<Icon icon={ArrowTopRightOnSquareIcon}/>}
                buttonAction={{
                    as: "reactRouterLink",
                    actionProps: {to: router.employeeEnvironment.absolutePath(), target: "_blank"}
                }}
                showInRowBreakpoint={"2xl"}
            >
                <FormattedMessage id={"employeeLogin"}/>
            </ActionRowButton>

            <ActionRowButton
                color={"secondary"}
                iconBefore={<Icon icon={ClockIcon}/>}
                buttonAction={{
                    as: "reactRouterLink",
                    actionProps: {to: router.timesheet.absolutePath()}
                }}
                showInRowBreakpoint={"2xl"}
            >
                <FormattedMessage id={"timesheet"}/>
            </ActionRowButton>

            {clockedStatusFilter({statusFilter, setSearchParams, intl, applyTooltip})}

            <ActionRowButton
                iconBefore={<Icon icon={PlusIcon}/>}
                buttonAction={{
                    as: "reactRouterLink",
                    actionProps: {to: router.newEmployee.absolutePath()}
                }}
            >
                <FormattedMessage id={"newEmployee"}/>
            </ActionRowButton>
        </ActionRow>
    );
};

export default EmployeesPageHeadingActions;